<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('直播课程.课程标题')">
                <a-input v-model="queryParam.courseTitle" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('直播课程.老师名称')">
                <a-input v-model="queryParam.teacherName" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="课程分类">
                <a-select v-model="queryParam.categoryId" placeholder="请选择课程分类" allow-clear>
                  <a-select-option v-for="category in categoryList" :key="category.id" :value="category.id">
                    {{ category.categoryName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['livecourse:liveCourse:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['livecourse:liveCourse:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 章节管理 -->
      <chapter-modal ref="chapterModal" :courseId="selectedCourseId" :visible="chapterModalVisible" @cancel="chapterModalVisible = false" />
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="courseMainImage" slot-scope="text, record">
          <img v-if="record.courseMainImage" :src="record.courseMainImage" style="width: 60px; height: 60px; object-fit: cover;" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="categoryName" slot-scope="text, record">{{ record.categoryName || '未分类' }}</span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['livecourse:liveCourse:edit']">
            <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['livecourse:liveCourse:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
          <a-divider type="vertical" />
          <a @click="handleChapter(record)" v-hasPermi="['livecourse:liveCourseChapter:list']">
            <a-icon type="ordered-list" />{{$t('直播课程.章节管理')}}
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageLiveCourse, delLiveCourse } from '@/api/livecourse/liveCourse'
import { listLiveCourseCategory } from '@/api/livecourse/liveCourseCategory'
import CreateForm from './modules/CreateForm'
import ChapterModal from './modules/ChapterModal'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'LiveCourse',
  components: {
    CreateForm,
    ChapterModal
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      categoryList: [],
      loading: false,
      total: 0,
      selectedRowKeys: [],
      multiple: true,
      chapterModalVisible: false,
      selectedCourseId: null,
      queryParam: {
        courseTitle: undefined,
        teacherName: undefined,
        categoryId: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('直播课程.课程主图'), dataIndex: 'courseMainImage', scopedSlots: { customRender: 'courseMainImage' } },
        { title: this.$t('直播课程.课程标题'), dataIndex: 'courseTitle' },
        { title: '课程分类', dataIndex: 'categoryName', scopedSlots: { customRender: 'categoryName' } },
        { title: this.$t('直播课程.课程评价星级'), dataIndex: 'courseRating' },
        { title: this.$t('直播课程.课程标签'), dataIndex: 'courseTags' },
        { title: this.$t('直播课程.教师姓名'), dataIndex: 'teacherName' },
        { title: this.$t('直播课程.章节总数'), dataIndex: 'chapterCount' },
        { title: this.$t('直播课程.小节总数'), dataIndex: 'sectionCount' },
        { title: this.$t('直播课程.创建时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' } },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  created() {
    this.loadCategoryList()
    this.getList()
  },
  methods: {
    loadCategoryList() {
      listLiveCourseCategory().then(response => {
        this.categoryList = response.data || []
      })
    },
    getList() {
      this.loading = true
      pageLiveCourse(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { pageNum: 1, pageSize: 10 }
      this.handleQuery()
    },
    handleDelete(row) {
      const that = this
      this.$confirm({
        title: this.$t('通用.文本.确认删除'),
        content: this.$t('通用.文本.删除确认数据'),
        onOk() {
          const ids = row.id || that.selectedRowKeys
          delLiveCourse(Array.isArray(ids) ? ids.map(id => ({ id })) : [{ id: ids }]).then(() => {
            that.getList()
            that.$message.success(that.$t('通用.文本.删除成功'))
          })
        }
      })
    },
    handleChapter(record) {
      this.selectedCourseId = record.id
      this.chapterModalVisible = true
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>
